import { render } from "./TypeDocument.vue?vue&type=template&id=607c8c26"
import script from "./TypeDocument.vue?vue&type=script&lang=js"
export * from "./TypeDocument.vue?vue&type=script&lang=js"

import "./TypeDocument.vue?vue&type=style&index=0&id=607c8c26&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__